import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';
import moment from 'moment';
import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectMedicalExpenseCFStep, makeSelectMedicalExpenseCFStepErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetFormData,
  resetFormTravelInterruption,
  resetFormTravelDelay,
  resetFormEuropeanUnionData,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR } from './constants';
import { PrescriptionMedicinesForInjury } from './components/PrescriptionMedicinesForInjury';
import { PrescriptionMedicinesNotInjury } from './components/PrescriptionMedicinesNotInjury';
import { saveFormData } from '../actions';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import TimePickerInput from '../../../components/TimePickerInput';
import CurrencySelector from '../components/CurrencySelector';
import { AdditionalList } from './components/Additional';
import { makeSelectInsuredsList, makeSelectIsClaimForFieldEnabled } from '../../App/selectors';

import {
  ErrorMessage,
  Validate,
} from '../../../components/Validation/';
import { required, checkDateOnly } from '../../../utils/validation/validator';
import { stepMedicalExpensesExpenseLookup } from '../../FastCover/dataMapper/claimCodeMapper';

export class MedicalExpenseCFStep extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onPrescriptionMedicinesNotInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesNotInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onPrescriptionMedicinesForInjuryChange = (data) => {
    this.props.onFormDataChange('form.prescriptionMedicinesForInjury', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  onMedicalExpenseItemsChange = (data) => {
    this.props.onFormDataChange('form.lossInformationItemsMedicalExpense', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleChangeAmount = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^\d*(\.\d{0,2})?$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value)) {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleChangePhoneNumber = (propertyName) => (event) => {
    const target = event.target;
    const regex = /^[0-9-]+$/;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if (regex.test(value) || value === '') {
      this.props.onFormDataChange(propertyName, value);
    }
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  handleChangeClaimingFor = (propertyName) => (event) => {
    const target = event.target;
    const value = target.name;
    this.props.onFormDataChange(propertyName, value);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  handleUncheckedFormState = (field, resetAction) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    if (value === 'false') {
      resetAction();
    }

    this.handleChange(field)(event);
  };

  handleCurrencyChange = (propertyName) => (value) => {
    this.props.onFormDataChange(propertyName, value);
  }


  renderPrescriptionMedicinesForInjury() {
    const { prescriptionMedicinesForInjury } = this.props.form;
    const newPrescriptionMedicinesForInjury = this.appendIds(prescriptionMedicinesForInjury);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <PrescriptionMedicinesForInjury
          data={newPrescriptionMedicinesForInjury}
          onChange={this.onPrescriptionMedicinesForInjuryChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }


  renderPrescriptionMedicinesNotInjury() {
    const { prescriptionMedicinesNotInjury } = this.props.form;
    const newPrescriptionMedicinesNotInjury = this.appendIds(prescriptionMedicinesNotInjury);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <PrescriptionMedicinesNotInjury
          data={newPrescriptionMedicinesNotInjury}
          onChange={this.onPrescriptionMedicinesNotInjuryChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderMedicalExpenseAdditionalItems() {
    const { lossInformationItemsMedicalExpense = [] } = this.props.form;
    const newLossInformationItems = this.appendIds(lossInformationItemsMedicalExpense);
    const { isSummary, submitted, insuredsList, isClaimForFieldEnabled } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <AdditionalList
          data={newLossInformationItems}
          onChange={this.onMedicalExpenseItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
          insuredsList={insuredsList}
          isClaimForFieldEnabled={isClaimForFieldEnabled}
        />
      </div>
    );
  }

  renderHospitalAndMedicalExpenses() {
    const {
      isTheClaimTheResultOfAniLLness,
      accidentStartDateForIllness,
      detailsForIllness,
      isTheClaimTheResultOfAccidentOrInjury,
      detailsForAccident,
      wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity,
      ifOtherPleaseDescribeForHospital,
      otherDescriptionPleaseProvide,
      didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness,
      wereYouTravelingToReceiveMedicalTreatment,
      areYouPregnant,
    } = this.props.isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    const question1 = isTheClaimTheResultOfAniLLness === 'true';
    const question2 = isTheClaimTheResultOfAccidentOrInjury === 'true';
    const question3 = wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity === 'true';
    return (
      <div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.hospitalAndMedicalExpenses} />
            </PageSectionHeader>
          </div>
        </div>
        {this.renderMedicalExpenseAdditionalItems()}
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.isTheClaimTheResultOfAniLLness} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly || question2}
                  type="radio"
                  value="true"
                  checked={isTheClaimTheResultOfAniLLness === 'true'}
                  onChange={this.handleChange('form.isTheClaimTheResultOfAniLLness')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={isTheClaimTheResultOfAniLLness === 'false'}
                  onChange={this.handleChange('form.isTheClaimTheResultOfAniLLness')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {isTheClaimTheResultOfAniLLness === 'true' &&
          <div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-4 form-group'}>
                <Validate
                  name="accidentStartDateForIllness"
                  validators={[checkDateOnly, required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={accidentStartDateForIllness}
                  fieldName={messages.accidentStartDateForIllness}
                >
                  <DatePicker
                    position={'bottom-start'}
                    disabled={isReadOnly}
                    name="accidentStartDateForIllness"
                    type="text"
                    onDayChange={this.handleDayChange('form.accidentStartDateForIllness')}
                    value={accidentStartDateForIllness}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentStartDateForIllness' }) }}
                    />
                  </ErrorMessage>
                  <ErrorMessage for="checkDateOnly">
                    <FormattedMessage
                      {...messages.checkEventDate}
                      values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.accidentStartDateForIllness' }) }}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-8 form-group'}>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="detailsForIllness"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={detailsForIllness}
                  fieldName={messages.describeYourIllness}
                >
                  <Textbox
                    name="detailsForIllness"
                    type="text"
                    onChange={this.handleChange('form.detailsForIllness')}
                    value={detailsForIllness}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.describeYourIllness}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          </div>
        }
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.isTheClaimTheResultOfAccidentOrInjury} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly || question1}
                  type="radio"
                  value="true"
                  checked={isTheClaimTheResultOfAccidentOrInjury === 'true'}
                  onChange={this.handleChange('form.isTheClaimTheResultOfAccidentOrInjury')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={isTheClaimTheResultOfAccidentOrInjury === 'false'}
                  onChange={this.handleChange('form.isTheClaimTheResultOfAccidentOrInjury')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {isTheClaimTheResultOfAccidentOrInjury === 'true' &&
          <div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="detailsForAccident"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={detailsForAccident}
                  fieldName={messages.detailsForAccident}
                >
                  <TextArea
                    disabled={isReadOnly}
                    name="detailsForAccident"
                    type="text"
                    onChange={this.handleChange('form.detailsForAccident')}
                    value={detailsForAccident}
                    isSummary={isSummary}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.detailsForAccident}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          </div>
        }
        {isTheClaimTheResultOfAccidentOrInjury === 'true' &&
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly || question1}
                    type="radio"
                    value="true"
                    checked={wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity === 'true'}
                    onChange={this.handleChange('form.wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity === 'false'}
                    onChange={this.handleChange('form.wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity')}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {(wasTheAccidentOrInjuryTheResultOfPlayingASportOrDueToAHazardousActivity === 'true' && isTheClaimTheResultOfAccidentOrInjury === 'true') &&
          <div className={'ml-2 row'}>
            <div className={'col-sm-12 form-group'}>
              <Validate
                name="ifOtherPleaseDescribeForHospital"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={ifOtherPleaseDescribeForHospital}
                fieldName={messages.otherDescription}
              >
                <TextArea
                  disabled={isReadOnly}
                  name="ifOtherPleaseDescribeForHospital"
                  type="text"
                  onChange={this.handleChange('form.ifOtherPleaseDescribeForHospital')}
                  value={ifOtherPleaseDescribeForHospital}
                  isSummary={isSummary}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.otherDescription' }) }}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>
        }
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness === 'true'}
                  onChange={this.handleChange('form.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness === 'false'}
                  onChange={this.handleChange('form.didAnyPhysicianProhibitYouFromTravelingByAirOrOtherwiseDueToThisInjuryIllness')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.wereYouTravelingToReceiveMedicalTreatment} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={wereYouTravelingToReceiveMedicalTreatment === 'true'}
                  onChange={this.handleChange('form.wereYouTravelingToReceiveMedicalTreatment')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={wereYouTravelingToReceiveMedicalTreatment === 'false'}
                  onChange={this.handleChange('form.wereYouTravelingToReceiveMedicalTreatment')}
                // onClick={this.props.onResetFormTravelInterruption}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        {wereYouTravelingToReceiveMedicalTreatment === 'true' &&
          <div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-12 form-group'}>
                <Validate
                  name="ifOtherPleaseDescribeForHospital"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={otherDescriptionPleaseProvide}
                  fieldName={messages.otherDescriptionPleaseProvide}
                >
                  <TextArea
                    disabled={isReadOnly}
                    name="otherDescriptionPleaseProvide"
                    type="text"
                    onChange={this.handleChange('form.otherDescriptionPleaseProvide')}
                    value={otherDescriptionPleaseProvide}
                    isSummary={isSummary}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.otherDescriptionPleaseProvide}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          </div>
        }
        <div className={'row'}>
          <div className={'col-sm-12 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.areYouPregnant} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={areYouPregnant === 'true'}
                  onChange={this.handleChange('form.areYouPregnant')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={areYouPregnant === 'false'}
                  onChange={this.handleChange('form.areYouPregnant')}
                // onClick={this.props.onResetFormTravelInterruption}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
      </div>
    );
  }

  renderPrescriptionMedicines() {
    const {
      changeTo,
      ifYesNameOfPhysicianCurrentlyTreatingThis,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isRenderAreYouClaimingForUnexpectedRecurrence = !!stepMedicalExpensesExpenseLookup.areYouClaimingForUnexpectedRecurrence.claimCode;
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div>
        {this.renderPrescriptionMedicinesForInjury()}
        {this.renderPrescriptionMedicinesNotInjury()}
        {isRenderAreYouClaimingForUnexpectedRecurrence &&
          <div className={'row'}>
            <div className={'col-sm-12 form-group'}>
              <PageSectionHeader>
                <FormattedMessage {...messages.changeTo} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="true"
                    checked={changeTo === 'true'}
                    onChange={this.handleChange('form.changeTo')}
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    value="false"
                    checked={changeTo === 'false'}
                    onChange={this.handleChange('form.changeTo')}
                  // onClick={this.props.onResetFormTravelInterruption}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>
        }
        {isRenderAreYouClaimingForUnexpectedRecurrence && changeTo === 'true' &&
          <div className={'ml-2 row'}>
            <div className={'col-sm-6 form-group'}>
              <Validate
                name="ifYesNameOfPhysicianCurrentlyTreatingThis"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={ifYesNameOfPhysicianCurrentlyTreatingThis}
                fieldName={messages.ifYesNameOfPhysicianCurrentlyTreatingThis}
              >
                <Textbox
                  name="ifYesNameOfPhysicianCurrentlyTreatingThis"
                  type="text"
                  onChange={this.handleChange('form.ifYesNameOfPhysicianCurrentlyTreatingThis')}
                  value={ifYesNameOfPhysicianCurrentlyTreatingThis}
                  disabled={isReadOnly}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.ifYesNameOfPhysicianCurrentlyTreatingThis}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className={'col-sm-6 form-group'}>
            </div>
          </div>}
      </div>
    );
  }

  render() {
    const {
      didYouContactAssistanceCompany,
      assistanceCaseReferenceNumberFileNumber,
      didYouHaveOtherMedicalInsurance,
      insuranceCarriersName,
      policyId,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const { isSummary, submitted, loading, intl } = this.props;
    const isReadOnly = submitted || isSummary;
    return (
      <div className="app-content">
        <div className={'row'}>
          <div className={'col-sm-5 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.didYouContactAssistanceCompany} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={didYouContactAssistanceCompany === 'true'}
                  onChange={this.handleChange('form.didYouContactAssistanceCompany')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={didYouContactAssistanceCompany === 'false'}
                  onChange={this.handleChange('form.didYouContactAssistanceCompany')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          {didYouContactAssistanceCompany === 'true' &&
            <div className={'col-sm-6 form-group'}>
              <Validate
                name="thirdPartySurName"
                validators={[required]}
                group={this.validatorGroup}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                defaultValue={assistanceCaseReferenceNumberFileNumber}
                fieldName={messages.assistanceCaseReferenceNumberFileNumber}
              >
                <Textbox
                  name="assistanceCaseReferenceNumberFileNumber"
                  type="text"
                  onChange={this.handleChange('form.assistanceCaseReferenceNumberFileNumber')}
                  value={assistanceCaseReferenceNumberFileNumber}
                  disabled={isReadOnly}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={{ defaultMessage: intl.formatMessage({ id: 'fastCover.stepMedicalExpenses.assistanceCaseReferenceNumberFileNumber' }) }}
                  />
                </ErrorMessage>
              </Validate>
            </div>}
          <div className={'col-sm-1 form-group'}></div>
        </div>
        <div className={'row'}>
          <div className={'col-sm-5 form-group'}>
            <PageSectionHeader>
              <FormattedMessage {...messages.didYouHaveOtherMedicalInsurance} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="true"
                  checked={didYouHaveOtherMedicalInsurance === 'true'}
                  onChange={this.handleChange('form.didYouHaveOtherMedicalInsurance')}
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  value="false"
                  checked={didYouHaveOtherMedicalInsurance === 'false'}
                  onChange={this.handleChange('form.didYouHaveOtherMedicalInsurance')}
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          <div className={'col-sm-7 form-group'}></div>
        </div>
        {didYouHaveOtherMedicalInsurance === 'true' &&
          <div>
            <div className={'row'}>
              <div className={'col-sm-12 form-group'}>
                <PageSectionHeader>
                  <FormattedMessage {...messages.ifYesPleaseProvide} />
                </PageSectionHeader>
              </div>
            </div>
            <div className={'ml-2 row'}>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="insuranceCarriersName"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={insuranceCarriersName}
                  fieldName={messages.insuranceCarriersName}
                >
                  <Textbox
                    name="insuranceCarriersName"
                    type="text"
                    onChange={this.handleChange('form.insuranceCarriersName')}
                    value={insuranceCarriersName}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.dateTripWasCancelledWithTravelSupplier}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
              <div className={'col-sm-6 form-group'}>
                <Validate
                  name="policyId"
                  validators={[required]}
                  group={this.validatorGroup}
                  addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                  validChangeInGroup={this.validatorGroup.validChangeInGroup}
                  validationCounter={this.state.validationCounter}
                  validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                  defaultValue={policyId}
                  fieldName={messages.policyId}
                >
                  <Textbox
                    name="cityOrTown"
                    type="text"
                    onChange={this.handleChange('form.policyId')}
                    value={policyId}
                    disabled={isReadOnly}
                  />
                  <ErrorMessage for="required">
                    <FormattedMessage
                      {...messages.isRequired}
                      values={messages.policyId}
                    />
                  </ErrorMessage>
                </Validate>
              </div>
            </div>
          </div>}
        {this.renderHospitalAndMedicalExpenses()}
        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.back' })}
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    {intl.formatMessage({ id: 'fastCover.button.next' })} &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  {intl.formatMessage({ id: 'fastCover.button.save' })}
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

MedicalExpenseCFStep.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetFormTravelInterruption: PropTypes.func,
  onResetFormTravelDelay: PropTypes.func,
  onResetFormData: PropTypes.func,
  onResetFormEuropeanUnionData: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
  intl: intlShape.isRequired,
  insuredsList: PropTypes.array,
  isClaimForFieldEnabled: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectMedicalExpenseCFStep(),
  errors: makeSelectMedicalExpenseCFStepErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
  insuredsList: makeSelectInsuredsList(),
  isClaimForFieldEnabled: makeSelectIsClaimForFieldEnabled(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) => dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetFormTravelInterruption: () => dispatch(resetFormTravelInterruption()),
  onResetFormTravelDelay: () => dispatch(resetFormTravelDelay()),
  onResetFormData: () => dispatch(resetFormData()),
  onResetFormEuropeanUnionData: () => dispatch(resetFormEuropeanUnionData()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'medicalExpenseCFStep', reducer });

export default compose(
  withReducer,
  withConnect,
  injectIntl,
)(MedicalExpenseCFStep);



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.CFTripCan.MedicalExpense/index.js